import React, { useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import { regions, weekdays } from "../../../utils/date";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";

const Widgets = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const [isBannersLoading, setIsBannersLoading] = useState(true);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/main/banners/`)
      .then((res) => {
        setBanners(res.data);
      })
      .then(() => {
        setIsBannersLoading(false);
      });
  }, []);

  const [today, setToday] = useState(new Date());
  const infos = [
    {
      name: "ashgabat",
    },
    {
      name: "ahal",
    },
    {
      name: "lebap",
    },
    {
      name: "mary",
    },
    {
      name: "balkan",
    },
    {
      name: "dashoguz",
    },
  ];
  const [city, setCity] = useState(0);
  // API KEY AND URL
  const apiKey = process.env.REACT_APP_OW_KEY;
  const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${infos[city].name}&appid=${apiKey}`;
  const [data, setData] = useState([]);

  // Side effect
  useEffect(() => {
    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => setData(data));
  }, [apiUrl]);

  const kelvinToFarenheit = (k) => {
    return (k - 273.15).toFixed(0);
  };

  useEffect(() => {
    // Live time
    const timer = setInterval(() => {
      setToday(new Date());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    // Change city
    const c_timer = setInterval(() => {
      if (city === 5) {
        setCity(0);
      } else {
        setCity(city + 1);
      }
    }, 5000);
    return () => {
      clearInterval(c_timer);
    };
  }, [city]);

  const variants = {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: 150 },
  };

  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.8 }}
      className="outer-right d-flex justify-content-center"
    >
      <Swiper
        slidesPerView={1}
        className="widget-banner"
        autoplay={{
          delay: 5000,
        }}
        modules={[Autoplay]}
      >
        {isBannersLoading === true
          ? "..."
          : banners.map((banner, index) => (
              <SwiperSlide className="year-name" key={index}>
                <a
                  href={banner.url === null ? "#!" : banner.url}
                  className="year-name"
                >
                  <img
                    src={process.env.REACT_APP_API_URL + banner.image}
                    alt="Icon"
                  />
                  <span>
                    {lang === "en"
                      ? banner["text_en"]
                      : lang === "ru"
                      ? banner["text_ru"]
                      : banner["text_tm"]}
                  </span>
                </a>
              </SwiperSlide>
            ))}
      </Swiper>
      <div className="d-flex">
        <div className="left header-stat ml-4">
          <h5 className="mb-1 text-center">
            {today.getHours() < 10 ? "0" + today.getHours() : today.getHours()}:
            {today.getMinutes() < 10
              ? "0" + today.getMinutes()
              : today.getMinutes()}
            :
            {today.getSeconds() < 10
              ? "0" + today.getSeconds()
              : today.getSeconds()}
          </h5>
          <p className="mb-0 text-center">
            {lang === "en"
              ? weekdays[today.getDay()].en
              : lang === "ru"
              ? weekdays[today.getDay()].ru
              : weekdays[today.getDay()].tm}{" "}
            <br />
            {today.getDate() < 10 ? "0" + today.getDate() : today.getDate()}.
            {today.getMonth() + 1 < 10
              ? "0" + (today.getMonth() + 1)
              : today.getMonth() + 1}
            .{today.getFullYear()}
          </p>
        </div>
        <div className="middle mx-3 dashed-line-v"></div>
        <div className="left header-stat weather-wrapper">
          <div className="degree-wrapper">
            <img
              src={
                data.weather
                  ? `https://openweathermap.org/img/w/${data.weather[0].icon}.png`
                  : require("./../../../assets/images/loading.gif")
              }
              alt="weather status icon"
              className="weather-icon"
            />
            <span className="degree">
              {data.main ? kelvinToFarenheit(data.main.temp) : "0"}°C
            </span>
          </div>
          <div className="other-infos">
            <p className="mb-0 text-center">
              <Icon.GeoAltFill />{" "}
              {data && data.name
                ? lang === "en"
                  ? regions[data.name]["en"]
                  : lang === "ru"
                  ? regions[data.name]["ru"]
                  : regions[data.name]["tm"]
                : ""}
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Widgets;
